/**
 * Writer level — the Odisseia progression: one level per LEVEL_XP words
 * written across all manuscripts. Shared by the dashboard HUD and the
 * sidebar rail-user card so both always agree.
 */
import type { Project } from '../types';

export const LEVEL_XP = 3_000;

export interface WriterLevel {
  level: number;
  xpIn: number;
  pct: number;
}

export function totalWordsOf(projects: Project[]): number {
  return projects.reduce(
    (sum, p) => sum + p.chapters.reduce((cs, c) => cs + c.wordCount, 0),
    0
  );
}

export function writerLevelOf(totalWords: number): WriterLevel {
  const level = Math.floor(totalWords / LEVEL_XP) + 1;
  const xpIn = totalWords % LEVEL_XP;
  return { level, xpIn, pct: Math.round((xpIn / LEVEL_XP) * 100) };
}

export function writerTitleOf(
  level: number,
  t: (key: string, fallback: string) => string
): string {
  if (level <= 1) return t('hud.titleApprentice', 'Aprendiz');
  if (level <= 3) return t('hud.titleScribe', 'Escriba');
  if (level <= 5) return t('hud.titleChronicler', 'Cronista');
  if (level <= 7) return t('hud.titleStoryteller', 'Contador de Histórias');
  if (level <= 10) return t('hud.titleNovelist', 'Romancista');
  if (level <= 14) return t('hud.titleWordsmith', 'Mestre das Palavras');
  return t('hud.titleLegend', 'Lenda');
}
